module.exports = new __parcel__URL__("advanced-roadmap-broadcast-image.09b197f3.svg").toString();